export const tradeRequestsState = {
  allTradeRequests: [],
  tradeRequestFormStatus: false,
  tradeRequestSelectedForEdit: null,//holding a complete tradeRequest Data
  tradeRequestShowDetailForm:false,
  tradeRequestSingleItem : null,//holding an item of trade request items
  tradeRequestSingleItemForEdit : null,
  tradeRequestItems : [],
  tradeRequestSelectedForDisplay:null,
  tradeRequestCategoryType:null,
  tradeRequestEditMode:false,//To controle edit mode of an item of trade request items
  tradeRequestIsEdit: false,// While editing order or orderItem in tradeRequestEditMode
  tradeRequestItemEditMode:false,
  tradeRequestResponsesPerItem: null,
  tradeRequestNumber:null,
  tradeRequestDate : null,
  tradeRequestResponsesHeader : null,
  tradeRequestSelectedForResponse :null,
  tradeRequestPageNumber : null,
  tradeRequestItemsPerPage :null,
  tradeRequestSelectedItem : null,
  tradeRequestCurrentList: null,
  tradeRequestDirectCurrentList: null,
  tradeRequestSelectedToFinalize: null,
  directOrderListPageNumber: null,
  directOrderListItemsPerPage: null,

};
